import ContactsDelete from './ContactsDelete';

export default ContactsDelete;
